var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagePolaroidUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 32H64C28.654 32 0 60.652 0 96V424C0 459.346 28.654 488 64 488H384C419.346 488 448 459.346 448 424C448 413.299 448 96 448 96C448 60.652 419.346 32 384 32ZM400 424C400 432.822 392.822 440 384 440H64C55.178 440 48 432.822 48 424V376H400V424ZM400 328H332.023C321.795 295.604 291.779 272 256 272H192C156.221 272 126.205 295.604 115.977 328H48V96C48 87.178 55.178 80 64 80H384C392.822 80 400 87.178 400 96V328ZM224 112C188.654 112 160 140.654 160 176S188.654 240 224 240S288 211.346 288 176S259.346 112 224 112Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePolaroidUser);
export default __webpack_public_path__ + "static/media/image-polaroid-user.51fd997bac847cb0be5b8073e1803e54.svg";
export { ForwardRef as ReactComponent };